import { useEffect, useState } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import MenuMap from "../components/menuMap/menuMap";
import ProductSwitcher from "../components/menuMap/ProductSwitcher";
import MenuPrincipal from "../components/menuPrincipal/menuPrincipal";
import styles from "./styles/Home.module.css";

const PRODUCT_PATHS = ["/", "/satelite", "/estacoes", "/wrf"];
// Radar, Satélite e WRF têm seus controles no player — só Estações usa o menu lateral.
const DRAWER_PATHS = ["/estacoes"];

export default function Layout() {
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth > 900 : false,
  );
  const [isDrawerPinned, setIsDrawerPinned] = useState(true);

  const isProductsArea = PRODUCT_PATHS.includes(location.pathname);
  const hasDrawer = DRAWER_PATHS.includes(location.pathname);
  const isPinnedDesktop = isDesktop && isDrawerPinned;
  const isDrawerVisible = hasDrawer && (isDrawerOpen || isPinnedDesktop);

  // Atualiza a variável CSS --drawer-width para que páginas filhas se adaptem
  useEffect(() => {
    const updateRoot = () => {
      try {
        const root = document.documentElement;
        if (isDrawerVisible) {
          const el = document.querySelector(`.${styles.menuDrawer}`) as HTMLElement | null;
          const width = el
            ? el.getBoundingClientRect().width
            : Math.min(window.innerWidth * 0.86, 360);
          root.style.setProperty("--drawer-width", `${width}px`);
          root.classList.add("drawer-open");
        } else {
          root.classList.remove("drawer-open");
          root.style.removeProperty("--drawer-width");
        }
      } catch { /* ignore */ }
    };

    updateRoot();
    window.addEventListener("resize", updateRoot);
    return () => window.removeEventListener("resize", updateRoot);
  }, [isDrawerVisible]);

  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth > 900);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (!isDesktop && isDrawerPinned) setIsDrawerPinned(false);
  }, [isDesktop, isDrawerPinned]);

  // Fecha o drawer ao navegar para rotas que não o utilizam
  useEffect(() => {
    if (!hasDrawer) setIsDrawerOpen(false);
  }, [hasDrawer]);

  // Evento customizado para abrir o drawer (disparado pelo switcher ao ir para Estações)
  useEffect(() => {
    const handler = () => setIsDrawerOpen(true);
    window.addEventListener("products:openMenu", handler as EventListener);
    return () => window.removeEventListener("products:openMenu", handler as EventListener);
  }, []);

  return (
    <>
      <MenuPrincipal />
      <main className={styles.container}>
        <div id="app-overlays" />

        {isProductsArea && <ProductSwitcher />}

        {hasDrawer && (
          <>
            {!isPinnedDesktop && (
              <button
                className={`${styles.hamburgerButton} ${
                  isDrawerVisible ? styles.hamburgerButtonOpen : ""
                }`}
                onClick={() => setIsDrawerOpen(prev => !prev)}
                aria-label="Abrir ou fechar menu de produtos"
                aria-expanded={isDrawerVisible}
              >
                <HiOutlineMenuAlt3 size={22} />
              </button>
            )}

            {isDrawerOpen && !isPinnedDesktop && (
              <button
                className={styles.drawerBackdrop}
                aria-label="Fechar menu"
                onClick={() => setIsDrawerOpen(false)}
              />
            )}

            <aside
              className={`${styles.menuDrawer} ${
                isDrawerVisible ? styles.drawerOpen : styles.drawerClosed
              }`}
            >
              {isDesktop && (
                <label className={styles.pinToggle}>
                  <input
                    type="checkbox"
                    checked={isDrawerPinned}
                    onChange={e => setIsDrawerPinned(e.target.checked)}
                  />
                  <span>Fixar menu</span>
                </label>
              )}
              <MenuMap />
            </aside>
          </>
        )}

        <Outlet />
      </main>
    </>
  );
}
